import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import '../styles/FaultsView.css'
import { fetchMatrixs } from '../actions/matrixs'
import { fetchMachines } from '../actions/machines'
import ErrorMessage from '../components/ErrorMessage'
import LoadingProgress from '../components/LoadingProgress'
import { Link } from 'react-router-dom'
import FaultsByCustomerList from '../components/FaultsByCustomerList'
import FaultsByMachineList from '../components/FaultsByMachineList'
import { resolveFaultCode, BROKEN_LOCK_PINCHO, BROKEN_LOCK_PESTILLO } from '../utils/faults'

class FaultsView extends React.Component {
  constructor(props) {
    super(props)
    // `ready` gates rendering on THIS view's own fetch completing, so we never
    // flash stale matrixs/machines left in the store by a previously visited
    // view (e.g. a single machine loaded from a details page).
    this.state = { filterText: '', ready: false }
  }

  componentDidMount() {
    this._mounted = true
    const done = () => { if (this._mounted) this.setState({ ready: true }) }
    Promise.all([
      this.props.fetchMatrixs(''),
      this.props.fetchMachines(),
    ]).then(done, done)
  }

  componentWillUnmount() {
    this._mounted = false
  }

  identifyFaults() {

    const { matrixs } = this.props

    if (!matrixs) {
      return <LoadingProgress />
    }

    // BROKEN_LOCK (split by HardType), GREEN_BLOCK, RED_BLOCK, PINPAD_BLOCK,
    // DOOR_BLOCK, PINPAD_ACTIVE

    let TOTAL_FAULTS = 0;

    let BROKEN_PINCHO = 0;
    let BROKEN_PESTILLO = 0;
    let GREEN_BLOCK = 0;
    let RED_BLOCK = 0;
    let PINPAD_BLOCK = 0;
    let DOOR_BLOCK = 0;
    let PINPAD_ACTIVE = 0;

    matrixs.forEach(matrix => {
      {
        matrix.Locker.forEach((lock, index) => {

          if (lock.FaultCode !== undefined && lock.Status === 'FL') {
            switch (resolveFaultCode(lock.FaultCode, lock.HardType)) {
              case BROKEN_LOCK_PINCHO:
                BROKEN_PINCHO++;
                TOTAL_FAULTS++;

                break;
              case BROKEN_LOCK_PESTILLO:
                BROKEN_PESTILLO++;
                TOTAL_FAULTS++;

                break;
              case 'GREEN_BLOCK':
                GREEN_BLOCK++;
                TOTAL_FAULTS++;

                break;
              case 'RED_BLOCK':
                RED_BLOCK++;
                TOTAL_FAULTS++;

                break;
              case 'PINPAD_BLOCK':
                PINPAD_BLOCK++;
                TOTAL_FAULTS++;

                break;
              case 'DOOR_BLOCK':
                DOOR_BLOCK++;
                TOTAL_FAULTS++;

                break;
              case 'PINPAD_ACTIVE':
                PINPAD_ACTIVE++;
                TOTAL_FAULTS++;

                break;
              default:
                break;
            }
          }
        })
      }
    })

    return (
      <div className="faults-kpi-wrapper pb-3">
        <div className="faults-kpi-row">

          <div className="fault-kpi-card total">
            <div className="kpi-icon"><i className="fas fa-exclamation-triangle"></i></div>
            <div className="kpi-content">
              <div className="kpi-label">TOTAL AVERÍAS</div>
              <div className="kpi-value">{TOTAL_FAULTS}</div>
            </div>
          </div>

          <div className="fault-kpi-card broken">
            <div className="kpi-icon"><i className="fas fa-toolbox"></i></div>
            <div className="kpi-content">
              <div className="kpi-label">Pinchos rotos</div>
              <div className="kpi-value">{BROKEN_PINCHO}</div>
            </div>
          </div>

          <div className="fault-kpi-card broken-slide">
            <div className="kpi-icon"><i className="fas fa-grip-lines-vertical"></i></div>
            <div className="kpi-content">
              <div className="kpi-label">Pestillos rotos</div>
              <div className="kpi-value">{BROKEN_PESTILLO}</div>
            </div>
          </div>

          <div className="fault-kpi-card green-block">
            <div className="kpi-icon"><i className="fas fa-exclamation-circle"></i></div>
            <div className="kpi-content">
              <div className="kpi-label">Pin verde (no abre)</div>
              <div className="kpi-value">{GREEN_BLOCK}</div>
            </div>
          </div>

          <div className="fault-kpi-card red-block">
            <div className="kpi-icon"><i className="fas fa-ban"></i></div>
            <div className="kpi-content">
              <div className="kpi-label">Pin rojo (no abre)</div>
              <div className="kpi-value">{RED_BLOCK}</div>
            </div>
          </div>

          <div className="fault-kpi-card pinpad-block">
            <div className="kpi-icon"><i className="fas fa-keyboard"></i></div>
            <div className="kpi-content">
              <div className="kpi-label">Teclado no enciende</div>
              <div className="kpi-value">{PINPAD_BLOCK}</div>
            </div>
          </div>

          <div className="fault-kpi-card door-block">
            <div className="kpi-icon"><i className="fas fa-door-closed"></i></div>
            <div className="kpi-content">
              <div className="kpi-label">Puerta no cierra</div>
              <div className="kpi-value">{DOOR_BLOCK}</div>
            </div>
          </div>

          <div className="fault-kpi-card pinpad-active">
            <div className="kpi-icon"><i className="fas fa-power-off"></i></div>
            <div className="kpi-content">
              <div className="kpi-label">Teclado encendido</div>
              <div className="kpi-value">{PINPAD_ACTIVE}</div>
            </div>
          </div>

        </div>
      </div>
    )
  }

  render() {
    const { matrixs, machines } = this.props
    const { filterText, ready } = this.state

    if (!ready || !matrixs || !machines) {
      return <LoadingProgress />
    }

    return (
      <div className="faults-view">
        {/* Header */}
        <div className="faults-header">
          <div className="faults-title-section">
            <h1 className="faults-title">
              <i className="fas fa-exclamation-triangle"></i>
              AVERÍAS
            </h1>
          </div>
          <div className="faults-actions">
            <input
              type="text"
              className="filter-input"
              placeholder="Filtrar por cliente o máquina"
              value={filterText}
              onChange={(e) => this.setState({ filterText: e.target.value })}
              style={{ width: '260px' }}
            />
            <Link to="/faults/report">
              <button type="button" className="btn btn-vw btn-action ml-2">
                <i className="fas fa-file-excel mr-1"></i>Informes de reparación
              </button>
            </Link>
          </div>
        </div>

        {/* Summary card */}
        {this.identifyFaults()}

        {/* Faults by customer & machine — two equal-width columns on md+ */}
        <div className="faults-columns-row">
          <div className="fault-column mb-3">
            <div className="card-section">
              <div className="card-header-custom bg-vw-dark"><i className="fas fa-users mr-2"></i>Averías por cliente</div>
              <div className="card-body-custom">
                <FaultsByCustomerList matrixs={matrixs} machines={machines} filterText={filterText} />
              </div>
            </div>
          </div>

          <div className="fault-column mb-3">
            <div className="card-section">
              <div className="card-header-custom bg-vw-dark"><i className="fas fa-cubes mr-2"></i>Averías por máquina</div>
              <div className="card-body-custom">
                <FaultsByMachineList matrixs={matrixs} machines={machines} filterText={filterText} />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  matrixs: state.matrixs.matrixs,
  machines: state.machines.machines,
  error: state.matrixs.error,
  loading: state.matrixs.loading,
  role: state.auth.role,
  form: state.form
})

const mapDispatchToProps = dispatch => ({
  fetchMatrixs: bindActionCreators(fetchMatrixs, dispatch),
  fetchMachines: bindActionCreators(fetchMachines, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(FaultsView)
